import React from "react";
import { Formik, Field, Form } from "formik";
import l from "components/util/l";
import { bodyContentMapper } from "components/studio/board/nodes/Node.lib";
import { renderHTML } from "components/util/render_util";

const FlowNoteView = ({
  message,
  isEditing = false,
  isMessageNote,
  flowNote = {},
  onClickSubmit
}) => {
  return (
    <div className="card">
      <div className="card-header">
        <h3 className="mb-0">
          {
            function(){
              if (isEditing)
                return l("Editar nota%PA129");
              if (isMessageNote)
                return l("Guardar como nota%PA128");
              return l("Crear nota%PA035");
            }()
          }
        </h3>
      </div>
      <div className="card-body">
        <Formik
          initialValues={flowNote}
          onSubmit={onClickSubmit}>
          {({ values, setFieldValue, submitForm }) =>
            <Form>

              <div class="form-group mb-3">
                <span class="d-flex justify-content-between pt-0 pb-2 px-0">
                  <span>{l("Título%PA036")}</span>
                </span>
                <div class="input-group">
                  <Field
                    type="text"
                    name="title"
                    placeholder={l("Ej. Nota de la conversación%PA038")}
                    class="form-control"
                    autocomplete="off"
                    maxlength="200"
                    autoFocus={true}
                  />
                </div>
              </div>

              <div class="form-group mb-3">
                <span class="d-flex justify-content-between pt-0 pb-2 px-0">
                  <span>{l("Descripción%GA077")}</span>
                </span>
                <div class="input-group">
                  <Field
                    as="textarea"
                    rows="4"
                    name="description"
                    placeholder={l("Ej. Descripción de la conversación%PA037")}
                    class="form-control"
                    autocomplete="off"
                    maxlength="200"
                  />
                </div>
              </div>

              {
                message != null && message.id &&
                <div class="form-group mb-3">
                  <span class="d-flex justify-content-between pt-0 pb-2 px-0">
                    <span>{l("Mensaje%GA093")}</span>
                  </span>
                  <div class="input-group">
                    <div class="card my-2">
                      <div class="card-body">
                        <div className="chat-note-item-message-content mb-2 font-italic">
                          {
                            function () {

                              const action = message?.action;
                              const content = message?.content;

                              const text = content.text;

                              return renderHTML(
                                action?.node && action.node.action?.type == "TRIGGER" && !action.is_form
                                  ? bodyContentMapper(action.node.action.ui_settings?.node, action.node.input_values,
                                    "execution_message", action.node.action.ui_settings.form)
                                  : (text)
                              )

                            }()
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              }

              <button
                type="submit"
                className="btn btn-primary w-100"
              >
                {l("Guardar%GA023")}
              </button>

            </Form>
          }
        </Formik>
      </div>
    </div>
  );
}

export default FlowNoteView;